export const Direccion=process.env.REACT_APP_SERVER_URL;
export const DireccionFront=process.env.REACT_APP_FRONTEND_URL;
